function InHouseIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#4299E1" />
      <path
        d="M12.182 16.4c1.434 0 2.59-1.072 2.59-2.4 0-1.328-1.156-2.4-2.59-2.4S9.59 12.672 9.59 14c0 1.328 1.157 2.4 2.59 2.4zm10.364-4.8h-6.91v5.6H8.727V10H7v12h1.727v-2.4h15.546V22H26v-7.2c0-1.768-1.546-3.2-3.454-3.2z"
        fill="#fff"
      />
    </svg>
  )
}

export default InHouseIcon
